import React from 'react';
import { useTranslation } from 'react-i18next';
import { GoalsPage } from './GoalsPage';
import { useFlairBreadcrumbHook } from '../../../../../hooks/useFlairBreadcrumbHook';
import { GoalsContextProvider } from './GoalsContext/GoalsContext';

const Goals: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { t } = useTranslation();

  useFlairBreadcrumbHook([
    { label: t('navigation.menuItems.personalDevelopment.title') },
    { label: t('performanceReview.subMenuItems.goals.title') },
  ]);

  return (
    <GoalsContextProvider isManagerView={false}>
      <GoalsPage />
    </GoalsContextProvider>
  );
};

export default Goals;
